import React, { useState } from "react";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import DemoModeDialog from "shared/ui/DemoModeDialog";
import Icon from "@mui/material/Icon";
import usePlanner from "features/planner/state/usePlanner";
import { isDemoMode } from "shared/config/appConfig";
import logger from "utils/logger";

export default function SaveButton() {
  const { hasUnsavedChanges, saveProgram, isProgramValid } = usePlanner();
  const [isDemoDialogOpen, setIsDemoDialogOpen] = useState(false);

  const disabled = !hasUnsavedChanges || !isProgramValid;

  const handleSave = async () => {
    if (isDemoMode) {
      setIsDemoDialogOpen(true);
      return;
    }

    try {
      logger.info("Saving program");
      await saveProgram();
    } catch (err) {
      logger.error("Error saving program", err);
    }
  };

  return (
    <>
      <MDBox
        onClick={disabled ? undefined : handleSave}
        sx={{
          width: { xs: "100%", md: "90%", lg: "100%" },
          maxWidth: "260px",
          paddingY: "10px",
          paddingX: "16px",
          borderRadius: "14px",

          cursor: disabled ? "default" : "pointer",
          userSelect: "none",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",

          transition: "all 0.18s ease",

          border: "2px solid",
          borderColor: disabled ? "grey.300" : "primary.main",
          backgroundColor: disabled ? "grey.200" : "primary.main",
          color: disabled ? "grey.500" : "white.main",

          opacity: disabled ? 0.6 : 1,

          "&:hover": disabled
            ? {}
            : {
                backgroundColor: "primary.focus",
                borderColor: "primary.focus",
                boxShadow: "none",
              },

          "&:active": disabled
            ? {}
            : {
                transform: "scale(0.97)",
              },
        }}
      >
        <Icon sx={{ fontSize: 18, color: "inherit" }}>save</Icon>

        <MDTypography
          sx={{
            fontSize: "0.88rem",
            fontWeight: 700,
            lineHeight: 1,
            color: "inherit",
          }}
        >
          Guardar
        </MDTypography>
      </MDBox>

      <DemoModeDialog open={isDemoDialogOpen} onClose={() => setIsDemoDialogOpen(false)} />
    </>
  );
}
